import {action, observable, runInAction, makeObservable} from 'mobx';
import {decorate, inject, injectable} from '@yosmanyga/di';
import {NotesApi} from '../../data';

class PlayNoteController {
    note: string;
    executing: boolean;

    constructor(private notesApi: NotesApi) {
        this.note = '';
        this.executing = false;

        makeObservable(this, {
            note: observable,
            executing: observable,
            prepare: action,
            execute: action,
            cancel: action,
        });
    }

    prepare = (value: string) => {
        runInAction(() => {
            this.note = value;
        });
    };

    execute = async () => {
        runInAction(() => {
            this.executing = true;
        });

        await this.notesApi.addNote(this.note);

        runInAction(() => {
            this.note = '';
            this.executing = false;
        });
    };

    cancel = () => {
        runInAction(() => {
            this.note = '';
        });
    };
}

decorate(injectable(), PlayNoteController);
decorate(inject(NotesApi), PlayNoteController, 0);

export {PlayNoteController};
